import { render, staticRenderFns } from "./BadLicence.vue?vue&type=template&id=d965a908&"
import script from "./BadLicence.vue?vue&type=script&lang=ts&"
export * from "./BadLicence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports